import globalStore from '@src/mobx-store/root-store/global-store';
import { thirdPartyAuthStore, xoyoAuthStore } from '@src/mobx-store/root-store/auth';

// noinspection SpellCheckingInspection
const rootStore = {
  globalStore,
  thirdPartyAuthStore,
  xoyoAuthStore
};

window.rootStore = rootStore;

const RootStoreContext = React.createContext(rootStore);

export const useRootStore = () => React.useContext(RootStoreContext);

export const RootStoreProvider = ({ children }) => {
  return <RootStoreContext.Provider value={rootStore}>{children}</RootStoreContext.Provider>;
};

export default rootStore;
